<template>
  <div class="d-flex flex-fill fill-height justify-center align-center">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="8"
          offset-sm="2"
          md="6"
          offset-md="3"
          lg="4"
          offset-lg="4"
        >
          <v-card>
            <v-card-title class="justify-center info white--text">
              Abrir Caixa
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-between py-4">
                <div>
                  <strong>Data: </strong>
                  {{ new Date() | moment("DD/MM/YYYY") }}
                </div>
                <div>
                  <strong>Hora: </strong> {{ new Date() | moment("hh:mm:ss") }}
                </div>
              </div>
              <div>
                <v-text-field-money
                  v-bind:properties="properties"
                  v-bind:options="options"
                  v-model="value"
                  label="Valor:"
                ></v-text-field-money>
                <v-textarea
                  v-model="description"
                  filled
                  label="Descrição:"
                ></v-textarea>
              </div>
            </v-card-text>
            <v-card-actions class="justify-space-between">
              <v-btn @click="$router.push('/')" text color="error">
                Fechar
              </v-btn>
              <v-btn color="info" @click="send"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import mixinSnack from "./../_mixins/snackbar";
import { mapMutations } from "vuex";
export default {
  name: "OpenBox",
  mixins: [mixinSnack],
  data() {
    return { value: 0, description: "" };
  },
  methods: {
    ...mapMutations(["setBox"]),
    async send() {
      const { value, description } = this;
      try {
        const {
          data: { box },
        } = await this.$axios.post("/box/open", { value, description });
        this.setBox(box);
        this.snackSuccess("Caixa aberto com sucesso!");
        await this.$router.push({ name: "report_openbox" });
      } catch (e) {
        const {
          response: {
            data: { error },
          },
        } = e;
        this.snackError(error);
      }
    },
  },
  computed: {
    properties: () => ({ filled: true, prefix: "R$", placeholder: " " }),
    options: () => ({
      locale: "pt-BR",
      length: 11,
      precision: 2,
      empty: null,
    }),
  },
};
</script>

<style scoped></style>
